import React, { useState, useEffect  } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import API_BASE_URL from "../apiConfig";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const FormularioRegistro = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nombres: "",
    apellidos: "",
    fechaNacimiento: "",
    codigoPostal: "",
    municipio: "",
    colonia: "",
    calle: "",
    numero: "",
    sector: "",
    whatsapp: "",
    instagram: "",
    ine: null,
    coloniasDisponibles: [],
    nivelId: "",
  });

  const [niveles, setNiveles] = useState([]);
  const [esColoniaManual, setEsColoniaManual] = useState(false);
  const [coloniaSeleccionada, setColoniaSeleccionada] = useState("");

  const [mensaje, setMensaje] = useState("");
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleColoniaChange = (e) => {
  const value = e.target.value;
  setColoniaSeleccionada(value);

  if (value === "otra") {
    setEsColoniaManual(true);
    setFormData({ ...formData, colonia: "" });
  } else {
    setEsColoniaManual(false);
    setFormData({ ...formData, colonia: value });
  }
};

  const handleFileChange = (e) => {
    setFormData({ ...formData, ine: e.target.files[0] });
  };

  const handleCodigoPostalBlur = async () => {
    if (formData.codigoPostal.length === 5) {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
          `${API_BASE_URL}/Formulario/ObtenerColoniasPorCP`,
          { codigoPostal: formData.codigoPostal },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.success) {
          setFormData((prevData) => ({
            ...prevData,
            municipio: response.data.municipio,
            coloniasDisponibles: response.data.colonias,
          }));
        } else {
          alert(response.data.message);
        }
      } catch (error) {
        console.error("Error al obtener colonias:", error);
      }
    }
  };

  useEffect(() => {
  const obtenerNiveles = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/Formulario/NivelParticipante`);
      setNiveles(response.data);
    } catch (error) {
      console.error("Error al cargar niveles:", error);
    }
  };

  obtenerNiveles();
}, []);


const handleSubmit = async (e) => {
  e.preventDefault();

  setLoading(true);

  const lider = localStorage.getItem("lider");
  const formDataToSend = new FormData();
  Object.entries(formData).forEach(([key, value]) => {
      if (key !== "coloniasDisponibles") {
          formDataToSend.append(key, value);
      }
  });

  formDataToSend.append("lider", lider);

  // ✅ Validar fecha de nacimiento (Mayor de 17 años)
  const fechaNacimiento = new Date(formData.fechaNacimiento);
  const hoy = new Date();
  let edad = hoy.getFullYear() - fechaNacimiento.getFullYear(); // 🔥 Cambié const a let

  if (
      fechaNacimiento.getMonth() > hoy.getMonth() ||
      (fechaNacimiento.getMonth() === hoy.getMonth() && fechaNacimiento.getDate() > hoy.getDate())
  ) {
      edad--; // Ahora sí podemos modificar la variable sin error
  }

  if (edad < 17) {
      toast.error(" Debes ser mayor de 18 años para registrarte.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
      });

      setLoading(false);
      return; // ⛔ Evita continuar con la petición si el usuario es menor de edad
  }

  try {
      const response = await axios.post(
          `${API_BASE_URL}/Formulario/RegistrarFormulario`,
          formDataToSend,
          {
              headers: {
                  "Content-Type": "multipart/form-data",
              },
              withCredentials: true,
          }
      );

      toast.success(" Participante registrado correctamente.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          style: {
              backgroundColor: "#081b29",
              color: "#ffffff",
              fontWeight: "bold",
              borderRadius: "8px",
          },
      });

      // Limpiar el formulario después del envío
      setFormData({
          nombres: "",
          apellidos: "",
          fechaNacimiento: "",
          codigoPostal: "",
          municipio: "",
          colonia: "",
          calle: "",
          numero: "",
          sector: "",
          whatsapp: "",
          instagram: "",
          ine: null,
          coloniasDisponibles: [],
          nivelId: "",
      });

      //  Redirige después de mostrar la notificación de enviado exitasamente,
      //  Redirige al menú del usuario
        setTimeout(() => {
          navigate("/menu");
        }, 1000);

  } catch (error) {
      console.error("Error al registrar el formulario:", error);

      toast.error(" El número ya fue registrado.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
      });

      setShowModal(true); // modal de error
  }

  setLoading(false);
};

  return (
    <div className="wrapper min-h-screen w-full max-w-lg flex justify-center items-center bg-gray-900 px-4 sm:px-6 md:px-8">
      <div className="form-boxr w-full max-w-lg p-6 md:p-12 rounded-lg shadow-md">

      <img src="/img/monytorlogoa.png" alt="Logo" className="login-image" />

      <h2 className="mb-4">Formulario de Registro</h2>

      <form onSubmit={handleSubmit} className="flex flex-col gap-4 text-white">

        <fieldset className="mb-4" >
          <legend className="font-semibold">Datos Generales</legend>
          <div className="mb-3">

          <div>
            <label className=" block text-white">Nombres:</label>
            <input
              type="text"
              name="nombres"
              value={formData.nombres}
              onChange={handleChange}
              className="w-full p-3 border rounded text-black"
              required
            />
          </div>

          <div>
            <label className="block text-white">Apellidos:</label>
            <input
              type="text"
              name="apellidos"
              value={formData.apellidos}
              onChange={handleChange}
              className="w-full p-3 border rounded text-black"
              required
            />
          </div>
          <div>
            <label className="block text-white">Fecha de Nacimiento:</label>
            <input
              type="date"
              name="fechaNacimiento"
              value={formData.fechaNacimiento}
              onChange={handleChange}
              className="w-full p-3 border rounded text-black"
              required
            />
          </div>
          <div>
            <label className="block text-white">Código Postal:</label>
            <input
              type="text"
              name="codigoPostal"
              value={formData.codigoPostal}
              onBlur={handleCodigoPostalBlur}
              onChange={handleChange}
              className="w-full p-3 border rounded text-black"
              maxLength="5"
              required
            />
          </div>
          <div>
            <label className="block text-white">Municipio:</label>
            <input
              type="text"
              name="municipio"
              value={formData.municipio}
              readOnly
              className="w-full p-3 border rounded text-black"
            />
          </div>

          {/* <div>
            <label className="block text-white">Colonia:</label>
            <select
              name="colonia"
              onChange={handleChange}
              value={formData.colonia}
              className="w-full p-3 border rounded text-black"
              required
            >
              <option value="">Selecciona una colonia</option>
              {formData.coloniasDisponibles.map((colonia, index) => (
                <option key={index} value={colonia}>
                  {colonia}
                </option>
              ))}
            </select>
          </div> */}
          <div>
              <label className="block text-white">Colonia:</label>

              {/* Select de colonias (solo se muestra si NO es manual) */}
              {!esColoniaManual && (
                <select
                  name="colonia"
                  value={coloniaSeleccionada}
                  onChange={handleColoniaChange}
                  className="w-full p-3 border rounded text-black"
                  required
                >
                  <option value="">Selecciona una colonia</option>
                  {formData.coloniasDisponibles.map((colonia, index) => (
                    <option key={index} value={colonia}>
                      {colonia}
                    </option>
                  ))}
                  <option value="otra">Otra (especificar)</option>
                </select>
              )}

              {/* Input para escribir colonia (solo si seleccionaron "otra") */}
              {esColoniaManual && (
                <input
                  type="text"
                  name="colonia"
                  value={formData.colonia}
                  onChange={handleChange}
                  className="w-full p-3 border rounded text-black mt-2"
                  placeholder="Escribe tu colonia"
                  required
                  autoFocus
                />
              )}
            </div>


         <div>
            <label className= "block text-white">Calle:</label>
            <input
              type="text"
              name="calle"
              value={formData.calle}
              onChange={handleChange}
              className="w-full p-3 border rounded text-black"
              required
            />
          </div>

          <div>
            <label className= "block text-white">Número de calle:</label>
            <input
              type="text"
              name="numero"
              value={formData.numero}
              onChange={handleChange}
              className="w-full p-3 border rounded text-black"
              required
            />
          </div>

          <div>
            <label className= "block text-white">Sector:</label>
            <input
              type="text"
              name="sector"
              value={formData.sector}
              onChange={handleChange}
              className="w-full p-3 border rounded text-black"
            />
          </div>

          </div>
        </fieldset>

        <fieldset className="mb-4">
          <legend>Datos de Contacto</legend>

          <div>
            <label className= "block text-white bx bx-phone">Whatsapp:</label>
            <input
              type="text"
              name="whatsapp"
              value={formData.whatsapp}
              onChange={handleChange}
              className="w-full p-3 border rounded text-black"
              required
            />
          </div>

          <div>
            <label className= "block text-white">Instagram:</label>
            <input
              type="text"
              name="instagram"
              value={formData.instagram}
              onChange={handleChange}
              className="w-full p-3 border rounded text-black"
            />
          </div>

        </fieldset>

        <fieldset className="mb-4">
          <legend>INE</legend>
          <div className="mb-3">
            <input
              type="file"
              name="ine"
              onChange={handleFileChange}
              className="form-control w-full p-3 border rounded-md text-black"
              required
            />
          </div>

          <div>
            <label className="block text-white">Nivel del Participante:</label>


            <select
              name="nivelId"
              value={formData.nivelId}
              onChange={handleChange}
              className="w-full p-3 border rounded text-black"
              required
            >

              <option value="">Asignar nivel al Participante</option>
              {[...niveles]
                .sort((a, b) => a.id - b.id) //Ordenar los niveles de mayor a menor
                .map((nivel) => (
                  <option key={nivel.id} value={nivel.id}>
                    {nivel.id} - {nivel.nombre}
                  </option>
              ))}

            </select>
          </div>

        </fieldset>

        <div className="d-flex justify-content-between">
          <button type="submit" className="btn btn-primary w-full md:w-auto px-6 py-3 bg-blue-600 text-white rounded-lg  transition">
            Registrar
          </button>
          <button type="button"
            onClick={() => navigate("/menu")}
            className="btn btn-primary w-full md:w-auto px-6 py-3 bg-blue-600 text-white rounded-lg  transition"
          >
            Regresar al Menú
          </button>
        </div>

      </form>
    </div>
    </div>

  );
};

export default FormularioRegistro;
